import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1642e626&scoped=true"
import script from "./dashboard.js?vue&type=script&lang=js&external"
export * from "./dashboard.js?vue&type=script&lang=js&external"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=1642e626&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642e626",
  null
  
)

export default component.exports